import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatChipListbox } from '@angular/material/chips';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import { BandeiraCartaoService } from 'src/app/service/bandeira-cartao.service';
import { CheckoutService } from 'src/app/service/checkout.service';
import { StorageService } from 'src/app/service/shared/storage.service';
import { ValidaCpfService } from 'src/app/service/shared/valida-cpf.service';
import { DialogLoadingComponent } from 'src/app/shared/components/dialog-loading/dialog-loading.component';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';

const FORMAS_PAGAMENTO: any = [
  {
    id_forma: 1,
    descricao: 'Cartão de Crédito',
  },
  {
    id_forma: 3,
    descricao: 'Boleto Bancário',
  },
  {
    id_forma: 4,
    descricao: 'PIX',
  },
]

@Component({
  selector: 'app-forma-pagamento',
  templateUrl: './forma-pagamento.component.html',
  styleUrls: ['./forma-pagamento.component.scss']
})
export class FormaPagamentoComponent implements OnInit {
  public readonly aba: string = 'formaPagamento';

  public isLoading: boolean = true;

  public form!: FormGroup;

  public resumo!: any;

  faBarcode = faBarcode;

  public forma_pagamento = FORMAS_PAGAMENTO;

  public formaPagamentoSelecionada!: number;

  public parcelas!: any;

  public dadosEscola = JSON.parse(this.storage.getEscola());

  public telefone_escola: string = '(15) 99753-7756';
  public prazo_entrega: string = 'Verificar data de entrega com a escola: ' + this.dadosEscola.telefone;
  public endereco_escola: string = `${this.dadosEscola.endereco}, ${this.dadosEscola.numero} - ${this.dadosEscola.bairro} - ${this.dadosEscola.cidade} - ${this.dadosEscola.estado} CEP: ${this.dadosEscola.cep}`;
  public nome_escola: string = this.dadosEscola.nome_escola;

  public frete: number = 0;

  id_administradora!: number;
  caminhoBandeira!: string;
  temBandeira: boolean = true;

  public exibeFormaPagamento: boolean = false;

  public listaMateriais!: any[]
  public listaProdutos!: any[]

  public totalPorDependente: any = [];
  public total: any = 0;
  // public total!: any;


  public displayedColumns: string[] = [
    'nome_dependente',
    'valor',
  ];
  public dataSource!: MatTableDataSource<any>;

  @ViewChild(MatChipListbox) chipListbox!: MatChipListbox;

  @ViewChild(MatAccordion) accordion!: MatAccordion;
  viewportScroller: any;

  private dialogRef!: MatDialogRef<DialogLoadingComponent>;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private storage: StorageService,
    private checkout: CheckoutService,
    private bandeiraCartao: BandeiraCartaoService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    if (this.storage.isloggedIn()) {
      this.nome_escola = JSON.parse(this.storage.getEscola()).nome_escola;
      this.carregaResumo();
      this.listaParcelas();
      this.initForm();
      this.pegaFormaPagemento();

      this.form.valueChanges.subscribe(value => {
        if (this.form.valid) {
          this.exibeFormaPagamento = true;
        }
      })
    } else {
      this.router.navigate(['/'])
    }
  }


  public pegaFormaPagemento() {
    this.form.get('id_forma_pagamento')?.valueChanges.subscribe(value => {
      this.configurarValidacoes(value);
      this.formaPagamentoSelecionada = value
    })
  }

  public pegaBandeira() {
    // Chame o serviço para obter a bandeira do cartão e atualizar o ícone
    this.caminhoBandeira = this.bandeiraCartao.getCardBrand(this.form.get('numero_cartao')?.value).caminho;
    this.form.get('id_administradora')?.setValue(this.bandeiraCartao.getCardBrand(this.form.get('numero_cartao')?.value).id);
  }

  public verificaBandeira() {
    if (this.caminhoBandeira == '' && this.form.get('numero_cartao')?.value != '') {
      this.temBandeira = false;
    } else {
      this.temBandeira = true;
    }
  }

  public selecionaAdministradora(id: number) {
    this.form.get('id_administradora')?.setValue(id);
  }

  public desmarcarOpcaoBandeira() {
    if (this.chipListbox) {
      this.chipListbox.value = null;
    }
  }

  private carregaResumo() {
    this.checkout.listaCheckOut({ guid: this.storage.getGUID() }).subscribe((dependentes) => {
      this.isLoading = false;
      if (dependentes[0].produtos.length === 0) {
        this.router.navigate(['/dependente']);
      }

      this.listaMateriais = dependentes;
      this.dataSource = new MatTableDataSource<any>(dependentes.produtos);
      this.operacaoTotalPorDependente();
    });
  }

  public operacaoTotalPorDependente() {
    // Inicializa o totalPorDependente como um objeto vazio
    this.totalPorDependente = {};

    this.listaMateriais.forEach((dependente: any) => {
      let soma = 0;

      // Verifica se há produtos para o dependente antes de calcular a soma
      if (dependente.produtos && dependente.produtos.length > 0) {
        dependente.produtos.forEach((produto: any) => {
          soma += parseFloat(produto.valor_total);
        });
      }

      // Atualiza o totalPorDependente apenas se houver produtos selecionados
      this.totalPorDependente[dependente.id_dependente] = soma;
    });

    // Calcula a soma total de todos os valores em totalPorDependente
    this.total = Object.values(this.totalPorDependente).reduce((acc: any, value) => acc + value, 0);
  }

  private listaParcelas() {
    this.checkout.listaParcelas(JSON.parse(this.storage.getEscola()).id_escola, this.storage.getGUID()).subscribe((parcelas) => {
      this.parcelas = Object.entries(parcelas);
    })
  }

  public configurarValidacoes(value: number) {
    const camposNaoRequeridos = ['titular', 'numero_cartao', 'id_administradora', 'quantidade_parcelas', 'validade', 'codigo_seguranca'];

    // Verifica se o formulário está definido
    if (this.form) {
      // Limpa as validações existentes
      camposNaoRequeridos.forEach(campo => {
        const campoControl = this.form.get(campo);
        if (campoControl) {
          campoControl.clearValidators();
          campoControl.updateValueAndValidity();
        }
      });

      // Adiciona as novas validações se id_forma_pagamento for igual a 1
      if (value == 1) {
        camposNaoRequeridos.forEach(campo => {
          const campoControl = this.form.get(campo);
          if (campoControl) {
            campoControl.setValidators([Validators.required]);
            campoControl.updateValueAndValidity();
          }
        });
      }
    }
  }

  private initForm() {
    this.form = this.formBuilder.group({
      nome_responsavel: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      fone_responsavel: ['', Validators.required],
      cpf: ['', [Validators.required,
      // Validators.pattern(/^(\d{3}\.){2}\d{3}\-\d{2}$/),
      Validators.minLength(11),
      ValidaCpfService.validate,]],
      id_forma_pagamento: [''],
      titular: [''],
      numero_cartao: [''],
      id_administradora: [this.id_administradora],
      quantidade_parcelas: [''],
      validade: [''],
      codigo_seguranca: [''],
    })
  }

  // verificaValidacao() {
  //   console.log(this.form.get('email')?.errors);
  // }

  public continuar(form: FormGroup) {
    if (!this.form.get('id_administradora')?.valid) {
      this.dialog.open(DialogComponent, { data: 'Você precisa selecionar a bandeira do cartão informado.' });
    }

    if (this.form.valid) {
      if (this.form.get('id_forma_pagamento')?.value == '') {
        this.dialog.open(DialogComponent, { data: 'Você precisa selecionar uma forma de pagamento para prosseguir.' });
      } else {
        this.dialogRef = this.dialog.open(DialogLoadingComponent, {
          disableClose: true, // Impede o fechamento ao clicar fora do diálogo
        });

        const dados = {
          ...form.value,
          guid: this.storage.getGUID(),
          dias_boleto: this.dadosEscola.dias_boleto
        }
        this.checkout.finalizaPedido(dados).subscribe({
          next: (res) => {
            if (res.status) {
              this.dialogRef.close();
              this.storage.clean();
              this.storage.saveIdPedido(res.id_pedido);
              this.router.navigate(['/finalizacao']);
            } else {
              this.dialogRef.close();
              this.desmarcarOpcaoBandeira();
              this.dialog.open(DialogComponent, { data: res.mensagem });
            }
          },
          error: (err) => {
            this.dialogRef.close();
            this.dialog.open(DialogComponent, { data: 'Ocorreu um erro ao processar o pedido. Tente novamente mais tarde.' });
            console.error('Erro ao finalizar pedido:', err);
          }
        })
      }
    }
  }

  public isInvalid(ctrlName: string): boolean | undefined {
    return this.form.get(ctrlName)?.invalid;
  }

  public mensagemDeErro(ctrlName: string): string {
    const field = this.form.get(ctrlName);

    if (field?.hasError('required')) {
      return 'Preencha o campo.';
    }

    if (ctrlName === 'cpf' && this.form.get('cpf')?.errors !== null) {
      return 'Digite um CPF válido.';
    }

    if (ctrlName === 'email' && this.form.get('email')?.errors !== null) {
      return 'Digite um e-mail válido.';
    }

    return '';
  }

}
